var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99963 0.399902C4.21179 0.399948 4.41524 0.484263 4.56523 0.634302L6.96523 3.0343C7.11096 3.18518 7.1916 3.38727 7.18977 3.59702C7.18795 3.80678 7.10382 4.00743 6.95549 4.15576C6.80716 4.30408 6.60651 4.38822 6.39675 4.39004C6.187 4.39186 5.98492 4.31123 5.83403 4.1655L3.99963 2.3311L2.16523 4.1655C2.01435 4.31123 1.81227 4.39186 1.60251 4.39004C1.39276 4.38822 1.19211 4.30408 1.04378 4.15576C0.895452 4.00743 0.811317 3.80678 0.809494 3.59702C0.807672 3.38727 0.888308 3.18518 1.03403 3.0343L3.43403 0.634302C3.58403 0.484263 3.78748 0.399948 3.99963 0.399902ZM1.03403 7.8343C1.18406 7.68433 1.3875 7.60007 1.59963 7.60007C1.81177 7.60007 2.01521 7.68433 2.16523 7.8343L3.99963 9.6687L5.83403 7.8343C5.98492 7.68858 6.187 7.60794 6.39675 7.60976C6.60651 7.61159 6.80716 7.69572 6.95549 7.84405C7.10382 7.99237 7.18795 8.19302 7.18977 8.40278C7.1916 8.61254 7.11096 8.81462 6.96523 8.9655L4.56523 11.3655C4.41521 11.5155 4.21177 11.5997 3.99963 11.5997C3.7875 11.5997 3.58406 11.5155 3.43403 11.3655L1.03403 8.9655C0.884057 8.81548 0.799805 8.61203 0.799805 8.3999C0.799805 8.18777 0.884057 7.98432 1.03403 7.8343Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.6483cb2fdd4c3c28f72ea1bd3f5688c0.svg";
export { ForwardRef as ReactComponent };